import { getAccountancyCompanies } from 'accountant/employer/employer/employerService';
import { returnFileFromResponse, downloadFile } from 'packages/common/utils/file';
import {
  REPORT_TYPES, STATUSES, STATUSES_LIST, COLUMN_ORDER_MAPPING, NO_REPORTS_SELECTED_ERROR,
} from './constants';
import resource from '../resources';

export function getEmployers() {
  return getAccountancyCompanies()
    .then(data => {
      return data.map(employer => {
        return {
          key: employer.tenantId,
          name: employer.name,
        };
      });
    });
}

function transformStatusesToSelectObject(status) {
  return {
    name: status.description,
    key: status.name,
  };
}

export function getStatuses() {
  return new Promise(resolve => {
    const result = STATUSES_LIST.map(transformStatusesToSelectObject);
    resolve(result);
  });
}

function mapSortParams(sort) {
  const sortBy = COLUMN_ORDER_MAPPING[sort?.sortBy] || COLUMN_ORDER_MAPPING.default;
  const sortOrder = (sort?.sortOrder === 'default' || !sort) ? 'desc' : sort.sortOrder;
  return [sortBy, sortOrder].join(',');
}

function buildParams({
  advanced, pagination, searchTerm, sort,
}) {
  return {
    ...(advanced?.employer ? { tenantIds: transformListParam(advanced.employer) } : {}),
    ...(advanced?.status ? { status: transformListParam(advanced.status) } : {}),
    page: pagination?.page - 1 || 0,
    size: pagination?.pageSize || 10,
    startPeriod: advanced?.date?.startDate,
    endPeriod: advanced?.date?.endDate,
    searchTerm,
    sort: mapSortParams(sort),
  };
}

function transformListParam(list) {
  return list.map(e => e.key).join(',');
}

function transformReportType(backupRequestReport) {
  return REPORT_TYPES.find(r => r.name === backupRequestReport.reportType);
}

function sortBackupRequests(one, other) {
  return REPORT_TYPES.indexOf(one) - REPORT_TYPES.indexOf(other);
}

function transformBackupRequest(backupRequest) {
  return {
    ...backupRequest,
    period: `${backupRequest.startPeriod} à ${backupRequest.endPeriod}`,
    reports: backupRequest
      .backupRequestReports?.map(transformReportType)
      .sort(sortBackupRequests),
  };
}

function transformResponse({ data }) {
  return {
    ...data,
    content: data.content.map(transformBackupRequest),
  };
}

export function getBackupRequests(params) {
  const paramsFormatted = buildParams(params);
  return resource
    .getBackupRequests(paramsFormatted)
    .then(transformResponse);
}

export function isBlockedToDownloadBackupRequest(backupRequest) {
  return backupRequest.status !== STATUSES.SUCCESS.name;
}

export function isBlockedToRemoveBackupRequest(backupRequest) {
  return backupRequest.status === STATUSES.PROCESSING.name;
}

export function downloadBackupRequests(ids) {
  return new Promise((resolve, reject) => {
    ids.forEach(id => {
      resource
        .downloadBackupRequest(id)
        .then(response => {
          const { file, fileName } = returnFileFromResponse(response);
          downloadFile(file, fileName);
          resolve();
        })
        .catch(reject);
    });
  });
}

export function removeBackupRequests(ids) {
  return resource.removeBackupRequests(ids);
}

export function requestBackup(data) {
  return resource.requestBackup(data);
}

export function getStatusBadgeTheme(status) {
  return STATUSES[status].badge;
}

export function getStatusBadgeText(status) {
  return STATUSES[status].description;
}

export function mapReportTypesSelected(reportTypes) {
  if (!reportTypes) return [];
  return reportTypes
    .filter(r => r.marked)
    .map(r => r.name);
}

export function validateSelectedReports(reports) {
  return new Promise((resolve, reject) => {
    if (!reports || reports.length === 0) {
      reject(NO_REPORTS_SELECTED_ERROR);
    } else {
      resolve();
    }
  });
}
